//@flow

export default class Environment {
  static DESKTOP: Environment;
  static BROWSER: Environment;

  _name: string;
  constructor(name: string) {
    this._name = name;
  }

  isDesktop(): boolean {
    return this === Environment.DESKTOP;
  }

  isBrowser(): boolean {
    return this === Environment.BROWSER;
  }

  static toEnum(envString: ?string): ?Environment {
    if (envString) {
      if (envString === this.DESKTOP._name) {
        return this.DESKTOP;
      }
      if (envString === this.BROWSER._name) {
        return this.BROWSER;
      }
    }
  }

  static onDesktop(env: Environment): Promise<void> {
    return new Promise((success, failure) => {
      if (env.isDesktop()) success();
      else failure();
    });
  }

  static onBrowser(env: Environment): Promise<void> {
    return new Promise((success, failure) => {
      if (env.isBrowser()) success();
      else failure();
    });
  }

  toString(): string {
    return this._name;
  }
}

Environment.BROWSER = new Environment('BROWSER');
Environment.DESKTOP = new Environment('DESKTOP');
